module.exports = __webpack_public_path__ + "static/media/wheat.161f699d.jpg";